import { getCookie, setCookie } from "./cookie-handling";
jQuery(function () {
    const TIMEOUT = 60000;
    const COOKIE_NAME = 'randomPopupClosed';
    const COOKIE_LIFE_SPAN = 14;
    const disallowedPages = [
        8012,
        8104,
    ];
    const bodyClasses = jQuery('body').attr('class');
    const pageIdMatch = bodyClasses.match(/page-id-(\d+)/);
    const pageId = pageIdMatch ? parseInt(pageIdMatch[1], 10) : null;
    if (!getCookie(COOKIE_NAME) && (pageId === null || disallowedPages.indexOf(pageId) === -1)) {
        const $popup = jQuery('.wm-randomPopup');
        const $myContentInfoPopup = jQuery('#myContentInfoPopup');
        if ($popup.length == 0)
            return;
        setTimeout(() => {
            jQuery($popup).find('.wm-popup').addClass('-show');
        }, TIMEOUT);
        jQuery($popup).find('.wm-popup__close').on('click', (e) => {
            setCookie(COOKIE_NAME, 'true', COOKIE_LIFE_SPAN);
            setTimeout(function () {
                $myContentInfoPopup.addClass('-show');
            }, TIMEOUT);
        });
        jQuery($popup).find('.wm-popup__backdrop').on('click', (e) => {
            if (jQuery(e.target).hasClass('wm-popup__backdrop')) {
                setCookie(COOKIE_NAME, 'true', COOKIE_LIFE_SPAN);
                setTimeout(function () {
                    $myContentInfoPopup.addClass('-show');
                }, TIMEOUT);
            }
        });
    }
});
